import { Topic } from "./topic.model";

export class TopicStructure {
  
  title: string;
  topics: Topic[];

  constructor(title: string, topics: Topic[]) {
    this.title = title;
    this.topics = topics;
  }

  public static constructTopicStructure(data: any): TopicStructure {
    return new TopicStructure(data.title, data.topics.map((topic: any) => Topic.constructTopic(topic)));
  }

  getFilteredTopics() {
    const filteredTopics = this.topics
      .filter(topic => topic.checked) // Filter topics where checked is true
      .map(topic => ({
        topic: topic.topic,
        subtopics: topic.subtopics
          .filter(subtopic => subtopic.checked) // Filter subtopics where checked is true
          .map(subtopic => ({
            topic: subtopic.topic
          }))
      }));
  
    return filteredTopics;
  }
}